import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { FormWidgetService } from '../form-widget.service';
import { StudentAssignmentOverviewModel } from 'common/models/page-models/student-assignment-overview/student-assignment-overview-model';
import { StudentAssignmentOverviewMetaModel } from 'common/models/page-models/student-assignment-overview/student-assignment-overview-meta-model';
import { StudentAssignmentOverviewDataService } from 'common/services/data-services/admin/students/student-assignment-overview-data.service';

@Injectable({
  providedIn: 'root',
})
export class StudentAssignmentOverviewWidgetService extends FormWidgetService<StudentAssignmentOverviewModel> {
  constructor(
    protected ds: StudentAssignmentOverviewDataService,
    protected systemService: SystemService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new StudentAssignmentOverviewMetaModel().getMetaModel();
    return meta;
  }
}
